// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Order.css */
/* .containerD {
    display: flex;
    justify-content: space-between; 
  } */

.orderBody {
  margin-top: 0;
  padding: 67px 16px 0;
  box-sizing: border-box;
  max-width: 100%;
}

.orders-table-area {
  padding: 0 16px 20px;
  box-sizing: border-box;
  max-width: 100%;
}

.mainDiv {
  max-width: 100%;
}

hr {
  margin-top: 0px;
  color: #f7f7f7;
}

.Dp {
  margin: 0;
  width: auto;
  color: #0f172a;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.3;
}

.containerD {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin: 0 0 14px;
  flex-wrap: nowrap;
  max-width: 100%;
  box-sizing: border-box;
}

.containerDd {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3%;
}

.HeaderD {
  margin: 0;
  margin-right: auto;
  flex-grow: 0;
  flex-shrink: 0;
}

.SearchD {
  font-size: inherit;
  margin: 0;
  flex-shrink: 0;
}

.uploadD {
  align-items: center;
  margin: 0;
  border-radius: 50px;
}

.newD,
.newwD,
.newwwD,
.newwwwD,
.newwwwwD {
  align-items: center;
  margin: 0;
  flex-shrink: 0;
  border-radius: 6px;
}

.inputD {
  size: 10px;
}

.headingD {
  text-decoration: none;
  font-size: 15px;
}

.searchboxD {
  width: 140px;
  height: 34px;
  padding: 0 10px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  color: #0f172a;
  font-size: 13px;
  box-sizing: border-box;
}

.searchboxD:focus {
  border-color: #79c6e9;
  outline: none;
}

.searchboxD:hover {
  border-color: #cbd5e1;
}

.buttonD {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  margin: 0 0 12px;
  border-bottom: 1px solid #e5e7eb;
}

.buttonD button {
  margin: 0;
  padding: 8px 12px;
  border: 0;
  border-bottom: 2px solid transparent;
  background-color: white;
  cursor: pointer;
  font-size: 15px;
}

.buttonD button:focus {
  color: #79c6e9;
  border-bottom: 2px solid #79c6e9;
}

.search-container {
  height: auto;
  margin: 0;
}

.buttonD button a:focus {
  color: #79c6e9;
}

.buttonD button a:hover {
  color: #79c6e9;
}

.buttonsD.highlighted {
  color: #0f172a;
  border-bottom: 2px solid #79c6e9;
}

.buttonD button a {
  padding: 0;
  border: 0;
  font-weight: 600;
  cursor: pointer;
  color: #64748b;
  text-decoration: none;
  font-size: 18px;
}

.buttonsD.highlighted a {
  color: #0f172a;
}

.dropdownD {
  padding: 0 8px;
  margin: 0;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  width: 140px;
  height: 34px;
  cursor: pointer;
  font-size: 12px;
  color: #0f172a;
  background: #fff;
  box-sizing: border-box;
  flex-shrink: 0;
}

.dropdownD:focus {
  border-color: #79c6e9;
  outline: none;
}

.choose-file-button-order {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(to top, rgb(227, 226, 226), white);
  border: 1px solid lightgray;
  border-radius: 6px;
  text-decoration: none;
  color: black;
}

.choose-file-button-order:hover {
  cursor: pointer;
}

.search-container {
  position: relative;
  font-size: 12px;
}

.search-icon {
  position: absolute;
  top: 50%;
  font-size: 20px;
  left: 10px;
  /* Adjust as needed */
  transform: translateY(-50%);
  margin-top: 3px;
}

.searchboxD {
  margin: 0;
  padding: 0 10px;
  border-radius: 6px;
  width: 140px;
  height: 34px;
  color: #0f172a;
}

.searchSelectD {
  width: 160px;
  cursor: pointer;
  appearance: auto;
}

.date-picker-container {
  display: flex;
  gap: 6px;
  align-items: center;
  margin: 0;
  flex-shrink: 0;
}

.date-filter-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.date-filter-sep {
  font-size: 12px;
  color: #666;
  margin: 0 2px;
}

.date-picker {
  display: flex;
  align-items: center;
  margin: 0;
  gap: 6px;
}

.date-picker input[type="date"] {
  margin: 0;
  padding: 0 8px;
  font-size: 13px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  height: 34px;
  width: 132px;
  box-sizing: border-box;
  color: #0f172a;
}

.date-picker input[type="date"]:focus {
  border-color: #79c6e9;
  outline: none;
}

.accountBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  /* margin-left: auto;
  margin-right: auto; */
  max-width: 95%;
  padding-left: 20px;
  padding-right: 0px;
}

.accountPageSearchbar {
  border: 1px solid #ccc;
  height: 37px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  font-size: 15px;
  line-height: 20px;
  margin-top: -10px;
  width: 150px;
  padding: 0 10px;
  margin-right: 10px;
  margin-left: 10px;
}

.accountPageDatePicker {
  padding: 5px;
  margin-top: -40px;
  border: 1px solid #ccc;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
  width: 147px;
  height: 38px;
  cursor: pointer;
}

.accountPageUploadButton {
  align-items: center;
  /* margin-right: 23px; */
  /* margin-left: 10px; */
  margin-top: 0.4%;
  border-radius: 50px;
}

@media (max-width: 1100px) {
  .containerD {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .HeaderD {
    width: 100%;
    margin-right: 0;
    margin-bottom: 4px;
  }
}

@media (max-width: 600px) {
  .orderBody {
    padding: 56px 8px 12px;
  }

  .Dp {
    font-size: 20px;
  }

  .buttonD {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Css/Order.css"],"names":[],"mappings":"AAAA,cAAc;AACd;;;KAGK;;AAEL;EACE,aAAa;EACb,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;;EAKE,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,SAAS;EACT,oCAAoC;EACpC,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oEAAoE;EACpE,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB;uBACqB;EACrB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Order.css */\n/* .containerD {\n    display: flex;\n    justify-content: space-between; \n  } */\n\n.orderBody {\n  margin-top: 0;\n  padding: 67px 16px 0;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.orders-table-area {\n  padding: 0 16px 20px;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n.mainDiv {\n  max-width: 100%;\n}\n\nhr {\n  margin-top: 0px;\n  color: #f7f7f7;\n}\n\n.Dp {\n  margin: 0;\n  width: auto;\n  color: #0f172a;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.3;\n}\n\n.containerD {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n  margin: 0 0 14px;\n  flex-wrap: nowrap;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.containerDd {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 3%;\n}\n\n.HeaderD {\n  margin: 0;\n  margin-right: auto;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.SearchD {\n  font-size: inherit;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.uploadD {\n  align-items: center;\n  margin: 0;\n  border-radius: 50px;\n}\n\n.newD,\n.newwD,\n.newwwD,\n.newwwwD,\n.newwwwwD {\n  align-items: center;\n  margin: 0;\n  flex-shrink: 0;\n  border-radius: 6px;\n}\n\n.inputD {\n  size: 10px;\n}\n\n.headingD {\n  text-decoration: none;\n  font-size: 15px;\n}\n\n.searchboxD {\n  width: 140px;\n  height: 34px;\n  padding: 0 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  color: #0f172a;\n  font-size: 13px;\n  box-sizing: border-box;\n}\n\n.searchboxD:focus {\n  border-color: #79c6e9;\n  outline: none;\n}\n\n.searchboxD:hover {\n  border-color: #cbd5e1;\n}\n\n.buttonD {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 8px;\n  margin: 0 0 12px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.buttonD button {\n  margin: 0;\n  padding: 8px 12px;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  background-color: white;\n  cursor: pointer;\n  font-size: 15px;\n}\n\n.buttonD button:focus {\n  color: #79c6e9;\n  border-bottom: 2px solid #79c6e9;\n}\n\n.search-container {\n  height: auto;\n  margin: 0;\n}\n\n.buttonD button a:focus {\n  color: #79c6e9;\n}\n\n.buttonD button a:hover {\n  color: #79c6e9;\n}\n\n.buttonsD.highlighted {\n  color: #0f172a;\n  border-bottom: 2px solid #79c6e9;\n}\n\n.buttonD button a {\n  padding: 0;\n  border: 0;\n  font-weight: 600;\n  cursor: pointer;\n  color: #64748b;\n  text-decoration: none;\n  font-size: 18px;\n}\n\n.buttonsD.highlighted a {\n  color: #0f172a;\n}\n\n.dropdownD {\n  padding: 0 8px;\n  margin: 0;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  width: 140px;\n  height: 34px;\n  cursor: pointer;\n  font-size: 12px;\n  color: #0f172a;\n  background: #fff;\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n\n.dropdownD:focus {\n  border-color: #79c6e9;\n  outline: none;\n}\n\n.choose-file-button-order {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background-image: linear-gradient(to top, rgb(227, 226, 226), white);\n  border: 1px solid lightgray;\n  border-radius: 6px;\n  text-decoration: none;\n  color: black;\n}\n\n.choose-file-button-order:hover {\n  cursor: pointer;\n}\n\n.search-container {\n  position: relative;\n  font-size: 12px;\n}\n\n.search-icon {\n  position: absolute;\n  top: 50%;\n  font-size: 20px;\n  left: 10px;\n  /* Adjust as needed */\n  transform: translateY(-50%);\n  margin-top: 3px;\n}\n\n.searchboxD {\n  margin: 0;\n  padding: 0 10px;\n  border-radius: 6px;\n  width: 140px;\n  height: 34px;\n  color: #0f172a;\n}\n\n.searchSelectD {\n  width: 160px;\n  cursor: pointer;\n  appearance: auto;\n}\n\n.date-picker-container {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.date-filter-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #333;\n  white-space: nowrap;\n}\n\n.date-filter-sep {\n  font-size: 12px;\n  color: #666;\n  margin: 0 2px;\n}\n\n.date-picker {\n  display: flex;\n  align-items: center;\n  margin: 0;\n  gap: 6px;\n}\n\n.date-picker input[type=\"date\"] {\n  margin: 0;\n  padding: 0 8px;\n  font-size: 13px;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  height: 34px;\n  width: 132px;\n  box-sizing: border-box;\n  color: #0f172a;\n}\n\n.date-picker input[type=\"date\"]:focus {\n  border-color: #79c6e9;\n  outline: none;\n}\n\n.accountBox {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 20px;\n  /* margin-left: auto;\n  margin-right: auto; */\n  max-width: 95%;\n  padding-left: 20px;\n  padding-right: 0px;\n}\n\n.accountPageSearchbar {\n  border: 1px solid #ccc;\n  height: 37px;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  font-size: 15px;\n  line-height: 20px;\n  margin-top: -10px;\n  width: 150px;\n  padding: 0 10px;\n  margin-right: 10px;\n  margin-left: 10px;\n}\n\n.accountPageDatePicker {\n  padding: 5px;\n  margin-top: -40px;\n  border: 1px solid #ccc;\n  margin-left: 10px;\n  margin-right: 10px;\n  border-radius: 5px;\n  width: 147px;\n  height: 38px;\n  cursor: pointer;\n}\n\n.accountPageUploadButton {\n  align-items: center;\n  /* margin-right: 23px; */\n  /* margin-left: 10px; */\n  margin-top: 0.4%;\n  border-radius: 50px;\n}\n\n@media (max-width: 1100px) {\n  .containerD {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n  }\n\n  .HeaderD {\n    width: 100%;\n    margin-right: 0;\n    margin-bottom: 4px;\n  }\n}\n\n@media (max-width: 600px) {\n  .orderBody {\n    padding: 56px 8px 12px;\n  }\n\n  .Dp {\n    font-size: 20px;\n  }\n\n  .buttonD {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
